var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgM2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_28",
    "data-name": "Layer 28"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57,6H7A1,1,0,0,0,6,7V57a1,1,0,0,0,1,1H36.59a1,1,0,0,0,1-1V39.92a1,1,0,0,0-2,0V56H8V40.92H26.89a1,1,0,0,0,1-1V30.54a1,1,0,0,0-2,0v8.38H8V22H26.89a1,1,0,0,0,1-1V8H38.71v6.92a1,1,0,1,0,2,0V8H56V22.88H39.71a1,1,0,0,0,0,2H56v14H45.33a1,1,0,0,0,0,2H56V56H47a1,1,0,0,0,0,2H57a1,1,0,0,0,1-1V7A1,1,0,0,0,57,6ZM25.89,20H8V8H25.89Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgM2);
export default __webpack_public_path__ + "static/media/m2.74f527bd4702098c4621045a8dc7940f.svg";
export { ForwardRef as ReactComponent };